import type { ReactNode } from 'react';
import { Icon } from '@/components/foundations';

export type PaginationProps = {
  /** Página atual (começa em 1). */
  page: number;
  pageCount: number;
  /** Texto à esquerda ("Mostrando 1 a 8 de 8 transações"). */
  summary: ReactNode;
  onChange?: (page: number) => void;
};

/** Rodapé da tabela (`.tx-foot` + `.pager`). */
export function Pagination({ page, pageCount, summary, onChange }: PaginationProps) {
  const pages = Array.from({ length: Math.max(pageCount, 1) }, (_, i) => i + 1);
  const go = (p: number) => p >= 1 && p <= pageCount && p !== page && onChange?.(p);
  return (
    <div className="tx-foot">
      <span>{summary}</span>
      <nav className="pager" aria-label="Paginação">
        <button type="button" aria-label="Anterior" aria-disabled={page <= 1 || undefined} onClick={() => go(page - 1)}><Icon name="chevL" /></button>
        {pages.map((p) => (
          <button type="button" key={p} className={p === page ? 'cur' : undefined} aria-current={p === page ? 'page' : undefined} onClick={() => go(p)}>{p}</button>
        ))}
        <button type="button" aria-label="Próxima" aria-disabled={page >= pageCount || undefined} onClick={() => go(page + 1)}><Icon name="chev" /></button>
      </nav>
    </div>
  );
}
